import React, {memo} from 'react'
import {Button} from 'semantic-ui-react'
import {useSafeState} from '../../hook'

const _Actions = (
  {
    style = {},
    prefix = '',
    onEdit,
    onRemove,
    onClone,
    onViewDocs,
    onViewResponse,
    onCopyTo,
    onArchive
  }
) => {
  const [actionsState, setState] = useSafeState({
    editing: false,
    removing: false,
    cloning: false,
    viewingDocs: false,
    viewingResponse: false,
    copyingTo: false,
    archiving: false
  })

  const onClick = async (e, handler, loadingKey) => {
    e.preventDefault()
    e.stopPropagation()
    const result = handler()
    if (result && result.then) {
      if (loadingKey) {
        setState({...actionsState, [loadingKey]: true})
      }
      await result
      if (loadingKey) {
        setState({...actionsState, [loadingKey]: false})
      }
    }
  }

  prefix = !!prefix ? `${prefix}-` : ''

  return (
    <div style={style}>
      {
        onViewDocs && (
          <div style={{float: 'left'}}>
            <Button title='Docs' circular compact size='mini' loading={actionsState.viewingDocs} basic icon='browser'
                    data-test={`${prefix}docs-action`}
                    onClick={async (e) => onClick(e, onViewDocs, 'viewingDocs')}/>
          </div>
        )
      }
      {
        onViewResponse && (
          <div style={{float: 'left'}}>
            <Button title='View' circular compact size='mini' loading={actionsState.viewingResponse} basic icon='eye'
                    data-test={`${prefix}view-action`}
                    onClick={async (e) => onClick(e, onViewResponse, 'viewingResponse')}/>
          </div>
        )
      }
      {
        onEdit && (
          <div style={{float: 'left'}}>
            <Button title='Edit' circular compact size='mini' loading={actionsState.editing} basic icon='edit'
                    data-test={`${prefix}edit-action`}
                    onClick={async (e) => onClick(e, onEdit, 'editing')}/>
          </div>
        )
      }
      {
        onClone && (
          <div style={{float: 'left'}}>
            <Button title='Clone' circular compact size='mini' loading={actionsState.cloning} basic icon='clone'
                    data-test={`${prefix}clone-action`}
                    onClick={async (e) => onClick(e, onClone, 'cloning')}/>
          </div>
        )
      }
      {
        onRemove && (
          <div style={{float: 'left'}}>
            <Button title='Remove' circular compact size='mini' loading={actionsState.removing} basic icon='remove'
                    data-test={`${prefix}remove-action`}
                    onClick={async (e) => onClick(e, onRemove, 'removing')}/>
          </div>
        )
      }
      {
        onCopyTo && (
          <div style={{float: 'left'}}>
            <Button title='Copy To' circular compact size='mini' loading={actionsState.copyingTo} basic icon='arrow right'
                    data-test={`${prefix}copy-to-action`}
                    onClick={async (e) => onClick(e, onCopyTo, 'copying to')}/>
          </div>
        )
      }
      {
        onArchive && (
          <div style={{float: 'left'}}>
            <Button title='Archive' circular compact size='mini' loading={actionsState.archiving} basic icon='archive'
                    data-test={`${prefix}archive-action`}
                    onClick={async (e) => onClick(e, onArchive, 'archiving')}/>
          </div>
        )
      }
    </div>
  )
}

let Actions = (props) => {
  return (<_Actions {...props}/>)
}

Actions = memo(Actions)

export {_Actions, Actions}

export default Actions